<div class="aru-tabs" *ngIf="!hide && !type">
  <button type="button" [ngClass]="getClass('list')" (click)="routeTo('list')" class="btn btn-square">
    <span>{{ tabsName.active }} {{ title ? title : ('' | titlecase) }} ({{ nActive ? nActive : 0 }})</span></button
  ><button type="button" [ngClass]="getClass('archived')" (click)="routeTo('archived')" class="btn btn-square">
    <span>{{ tabsName.archived | titlecase }} ({{ nArchived ? nArchived : '0' }})</span>
  </button>
</div>

<div class="aru-tabs" *ngIf="!hide && type">
  <button type="button" [ngClass]="getClass('flow')" routerLink="/inspection/flow" class="btn btn-square">
    <span>Inspection Flow</span></button
  ><button
    *ngIf="!isVendor"
    type="button"
    [ngClass]="getClass('waiting')"
    routerLink="/inspection/waiting"
    class="btn btn-square">
    <span>Waiting</span></button
  ><button
    *ngIf="!isVendor"
    type="button"
    [ngClass]="getClass('rejected')"
    routerLink="/inspection/rejected"
    class="btn btn-square">
    <span>Rejected</span></button
  ><button type="button" [ngClass]="getClass('accepted')" routerLink="/inspection/accepted" class="btn btn-square">
    <span>Accepted</span></button
  ><button type="button" [ngClass]="getClass('completed')" routerLink="/inspection/completed" class="btn btn-square">
    <span>Completed</span></button
  ><button
    *ngIf="!isVendor"
    type="button"
    [ngClass]="getClass('archived')"
    routerLink="/inspection/archived"
    class="btn btn-square">
    <span>Archived</span>
  </button>
</div>
